<script lang="ts">
  import { setContext } from "svelte";
  import Modal from "./Modal.svelte";
  import { errors } from "./stores";

  export let businessCode;

  setContext("errors", errors);

  let isOpen = false;
  const toggle = () => {
    isOpen = !isOpen;

    // hide booking footer at bottom of page
    // booking footer is mounted on profile pages
    const bookingFooter: HTMLElement = document.querySelector(".booking-footer");
    if (isOpen && bookingFooter) {
      bookingFooter.style.visibility = "hidden";
    } else if (!isOpen && bookingFooter) {
      bookingFooter.style.visibility = "visible";
    }
  };
</script>

<button
  type="button"
  class="text-center btn btn-outline-muted btn-block"
  on:click={toggle}>
  Ask Us a Question
</button>

<Modal bind:isOpen {businessCode} {toggle} />
